import { render } from "./SupplierDetailPlaceholderTab.vue?vue&type=template&id=7c004d79"
import script from "./SupplierDetailPlaceholderTab.vue?vue&type=script&lang=js"
export * from "./SupplierDetailPlaceholderTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__